import { render, staticRenderFns } from "./CompaniesListComponent.vue?vue&type=template&id=2a73e2ed&scoped=true&"
import script from "./CompaniesListComponent.vue?vue&type=script&lang=js&"
export * from "./CompaniesListComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesListComponent.vue?vue&type=style&index=0&id=2a73e2ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a73e2ed",
  null
  
)

export default component.exports